import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { BUOY_GPT_API_V1 } from 'src/interviews/requests/settings';

const useFormatMedications = () => {
  return useMutation<string[], Error, { value: string }>({
    mutationFn: async (data: { value: string }): Promise<string[]> => {
      const response = await axios.post(`${BUOY_GPT_API_V1}/bedrock/format-medication`, {
        data: data.value,
      });
      return response.data.content;
    },
  });
};

export default useFormatMedications;
